import { createAction, props } from '@ngrx/store';
import { Merchant } from './merchant-details.model';

export const updateMerchantDetailsAction = createAction(
	'[Merchant Details Response] Update Merchant Details',
	props<{ merchant: Merchant }>()
);

export const updateOrderMerchantDetailsAction = createAction(
	'[Merchant Details Response] Add Order Merchant Details',
	props<{ merchant: Merchant }>()
);

export const setDefaultLanguage = createAction(
	'[Merchant Details Effects] Set Default Language',
	props<{ language: string }>()
);
